
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"800","height":"800","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 2H9c-2.828 0-4.243 0-5.121.879C3 3.757 3 5.172 3 8v13.25H2a.75.75 0 000 1.5h15.25a.75.75 0 000-1.5H16v-3.5h1.571c.375 0 .679.304.679.679v.071a2.25 2.25 0 104.5 0V7.602c0-.157 0-.265-.006-.37a3.75 3.75 0 00-1.24-2.582c-.08-.07-.164-.138-.286-.236l-1.25-1a.75.75 0 10-.936 1.172l1.233.986c.144.116.194.156.237.195.443.397.711.954.745 1.549a6.1 6.1 0 01.003.306V8h-.75A1.5 1.5 0 0019 9.5v2.419a1.5 1.5 0 001.026 1.423l1.224.408v4.75a.75.75 0 01-1.5 0v-.071a2.179 2.179 0 00-2.179-2.179H16V8c0-2.828 0-4.243-.879-5.121C14.243 2 12.828 2 10 2zm-.114 7.357a.75.75 0 01.257 1.029l-.818 1.364H11a.75.75 0 01.643 1.136l-1.5 2.5a.75.75 0 11-1.286-.772l.818-1.364H8a.75.75 0 01-.643-1.136l1.5-2.5a.75.75 0 011.029-.257z","fill":"#1C274C"}})])
          )
        }
      }
    